import { useTheme } from "@/hooks/use-theme";
import logoNight from "@/assets/logo-passcar-night.avif";
import logoDay from "@/assets/logo-passcar-day.avif";

interface ThemeLogoProps {
  className?: string;
}

export function ThemeLogo({ className = "" }: ThemeLogoProps) {
  const { theme } = useTheme();

  const isDark = theme === "dark";

  return (
    <img
      src={isDark ? logoNight : logoDay}
      alt="PassCar"
      className={`${className} ${isDark ? "scale-[1.50] origin-left" : ""}`}
    />
  );
}
